import { render, staticRenderFns } from "./ManageCardCustomizationOptions.vue?vue&type=template&id=23c71ea0&scoped=true"
import script from "./ManageCardCustomizationOptions.vue?vue&type=script&lang=ts"
export * from "./ManageCardCustomizationOptions.vue?vue&type=script&lang=ts"
import style0 from "./ManageCardCustomizationOptions.vue?vue&type=style&index=0&id=23c71ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c71ea0",
  null
  
)

export default component.exports